/**
 * Breakpoints, mirrored from Tailwind's defaults so JS-side media queries and CSS-side
 * `md:` / `lg:` variants can never disagree.
 *
 *   mobile  < 768  ≤ tablet < 1024 ≤ desktop
 */
export const breakpoints = {
  mobile: 0,
  tablet: 768,
  desktop: 1024,
} as const;

export const mediaQueries = {
  /** Below the tablet breakpoint — the sidebar becomes a drawer here. */
  mobile: `(max-width: ${breakpoints.tablet - 1}px)`,
  tablet: `(min-width: ${breakpoints.tablet}px)`,
  desktop: `(min-width: ${breakpoints.desktop}px)`,
} as const;
